import React from 'react';
import c from 'classnames';

import { TextColor, Typography } from '@repo/ui';
import { SLIDE_BACKGROUND_COLORS } from '../slideBackgroundColors';

import ellipse1 from 'assets/images/summary/first-look/ellipse_1.svg';
import ellipse2 from 'assets/images/summary/first-look/ellipse_2.svg';
import microbes from 'assets/images/summary/first-look/microbes.svg';

import slideStyles from './Slides.module.scss';
import styles from './TopThreeIntro.module.scss';

interface TopThreeIntroProps {
  count: number;
}

export const TopThreeIntro: React.FC<TopThreeIntroProps> = ({ count }) => {
  return (
    <div
      className={c(slideStyles.slideWrapper, styles.slideContainer)}
      style={{ backgroundColor: SLIDE_BACKGROUND_COLORS.topThreeIntro }}
    >
      <div className={styles.contentContainer}>
        <img src={ellipse1} alt='ellipse' className={styles.ellipse1} />
        <img src={ellipse2} alt='ellipse' className={styles.ellipse2} />
        <img src={microbes} alt='microbes' className={styles.microbes} />
        <div className={styles.centerText}>
          <Typography variant='heading-2xl' weight='medium'>
            Top{' '}
            <Typography
              variant='heading-2xl'
              color={TextColor.DARKGREEN}
              weight='medium'
            >
              {count} {count === 1 ? 'thing' : 'things'}
            </Typography>
            {'\n'}we detected{'\n'}that we{'\n'}recommend{'\n'}attending to...
          </Typography>
        </div>
      </div>
    </div>
  );
};
